export const KILO_BASE_2 = 1_024;
export const MEGA_BASE_2 = 1_048_576;
export const GIGA_BASE_10 = 1_000_000_000;
export const GIGA_BASE_2 = 1_073_741_824; 
